import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import * as fromGraphQl from './issue-type.graphql';
import { ApolloService } from '../apollo.service';
import { IssueType } from '../../entities/issue/issue-type';

@Injectable()
export class IssueTypeService {
  constructor(private apolloService: ApolloService) {}

  public getIssueTypes(isActive?: boolean): Observable<IssueType[]> {
    const filter: fromGraphQl.IssueTypeFilter = {};
    if (isActive !== undefined) {
      filter.isActive = isActive;
    }
    return this.apolloService
      .query<fromGraphQl.GetIssueTypesResponse>(fromGraphQl.GET_ISSUETYPES_QUERY, { filter })
      .pipe(
        take(1),
        switchMap((result) => {
          return of(IssueType.createIssueTypes(result.data.getIssueTypes));
        })
      );
  }
}
